import { upperFirst } from 'lodash';
import { useTranslation } from 'react-i18next';

import useDeleteScheduleRuleset from 'Domain/schedule-ruleset/useDeleteScheduleRuleset';
import { useModal } from 'Store/modal';

const useOpenDeleteModal = () => {
  const { t } = useTranslation('schedule-ruleset');
  const { onOpenModal } = useModal();

  const { mutate: onDeleteScheduleRuleset } = useDeleteScheduleRuleset();

  const onOpenDeleteModal = (id, rulesetData, onSuccessCallback) => {
    const { account, type } = rulesetData || {};

    const accounts = account
      ?.map((acc) => {
        return `${upperFirst(acc?.name)} ${acc?.ecommerce}`;
      })
      .join(', ');

    const description = t('deleteRulesetDescription', { accountId: accounts || '', livestreamType: type || '' });

    onOpenModal({
      width: '400px',
      isOpen: true,
      type: 'cancel',
      title: t('deleteRulesetTitle'),
      contentDescription: description,
      showPrimaryButton: true,
      showSecondaryButton: true,
      primaryButtonText: t('deleteSubmitButton'),
      secondaryButtonText: t('buttonClose'),
      onClickPrimaryButton: () => {
        onDeleteScheduleRuleset(id, { onSuccess: onSuccessCallback });
      },
    });
  };

  return { onOpenDeleteModal };
};

export default useOpenDeleteModal;